import { PanelType } from '../../../../panels/types';

export const processMiningPanelType: PanelType = {
  name: 'process-mining',
  location: 'left',
};
